module.exports = __webpack_public_path__ + "img/21.37f37b16.jpg";